import axios from "axios";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

export interface SystemPrompt {
  id: number | null;
  content: string | null;
  created_at: string | null;
  prompt_type: string;
  default_prompt: string;
}

const BASE_URL = "/system/agentic/system_prompt";

export const systemPromptApi = {
  get: async (promptType: string): Promise<SystemPrompt> => {
    const { data } = await axios.get(`${BASE_URL}.json`, {
      params: { prompt_type: promptType },
    });
    return data;
  },

  create: async (
    content: string,
    promptType: string,
  ): Promise<SystemPrompt> => {
    const { data } = await axios.post(`${BASE_URL}.json`, {
      system_prompt: { content, prompt_type: promptType },
    });
    return data;
  },
};

export const systemPromptKeys = {
  all: ["system_prompt"] as const,
  byType: (type: string) => ["system_prompt", type] as const,
};

export function useSystemPrompt(promptType: string) {
  return useQuery({
    queryKey: systemPromptKeys.byType(promptType),
    queryFn: () => systemPromptApi.get(promptType),
  });
}

export function useUpdateSystemPrompt(promptType: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (content: string) =>
      systemPromptApi.create(content, promptType),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: systemPromptKeys.byType(promptType),
      });
    },
  });
}
